import React, { Component } from 'react'
import { Button, ButtonGroup } from 'reactstrap';

export default class ReduxFormButtonGroup extends Component {
  render() {
    const {
      input: { value, onChange },
      buttons,
      size,
      vertical,
      className
    } = this.props
    return (
      <ButtonGroup className={className} size={size || 'sm'} vertical={vertical}>
        {buttons.map(button => <Button color="default" className={value === button.value ? ' active' : ''} key={`button_${button.value}`} onClick={() => onChange(button.value)}>{button.icon ? button.icon : button.label}</Button>)}
      </ButtonGroup>
    )
  }
}